import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CustomerServiceList from 'components/Lists/CustomerServiceList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'
import { Container } from '../styles'

export default function CustomerBundles ({
  customer,
  onBalanceUpdate: handleBalanceUpdate = () => {}
}) {
  const [loading, setLoading] = useState (true)
  const [customerServices, setCustomerServices] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [customer])

  const getData = async () => {
    try {
      const { data: customerServices } = await cutileiApi.get (
        `/customers/${customer.id}/services?business_id=${businessId}&earned_from=bundle`,
        requestConfig
      )
      
      setCustomerServices (customerServices.sort (orderServices))
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const orderServices = (a, b) => {
    const dateA = a.bill?.date ? DateTime.fromISO (a.bill.date).toMillis () : 0
    const dateB = b.bill?.date ? DateTime.fromISO (b.bill.date).toMillis () : 0
    
    return dateB - dateA
  }

  const handleUpdate = creditValue => {
    getData ()
    if (handleBalanceUpdate) {
      const newBalance = customer.balance + creditValue
      handleBalanceUpdate (newBalance)
    }
  }

  return (
    <Container>
      {loading ? <Loading style={{marginBottom: 20}}/> : (
        <CustomerServiceList
          customer={customer}
          customerServices={customerServices}
          onUpdate={handleUpdate}
        />
      )}
    </Container>
  )
}
